import { useTranslation } from 'react-i18next'

import bookingSvg from '@/assets/images/booking.svg'
import { Checkbox } from '@/components/ui/checkbox'

interface TourModalContentProps {
  onDontShowAgain: (value: boolean) => void
}

export const TourModalContent: React.FC<TourModalContentProps> = ({
  onDontShowAgain,
}) => {
  const { t } = useTranslation()

  return (
    <div className="relative overflow-hidden bg-header bg-cover bg-center p-4">
      <div className="h-full flex flex-col justify-between">
        <div className="backdrop-blur-sm bg-primaryDark/60 rounded-xl p-4 w-full h-full flex flex-col">
          <div className="space-y-6">
            <div className="space-y-1">
              <img src={bookingSvg} alt="Booking Logo" className="h-8 mb-6" />
              <h1 className="text-4xl text-white font-light">
                {t('tour-welcome-title')}
                <br />
                <span className="font-semibold">
                  {t('tour-welcome-subtitle')}
                </span>
              </h1>
            </div>
            <p className="text-white font-light">
              {t('tour-welcome-description')}
            </p>
            <p className="text-white font-light">{t('tour-efficiency-text')}</p>
          </div>
          <div className="mt-auto flex items-center space-x-2">
            <Checkbox id="dont-show-again" onCheckedChange={onDontShowAgain} />
            <label
              htmlFor="dont-show-again"
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-white"
              aria-label={t('tour-dont-show-again')}
            >
              {t('tour-dont-show-again')}
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}
